module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Al3I"
    }
  }, [_c('h1', {
    staticClass: "h1",
    attrs: {
      "id": "pAn8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/loi#d3"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h1', {
    staticClass: "h1a",
    attrs: {
      "id": "pAyZ"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/loi#d3"
    }
  }, [_vm._v("Addressing the Two Intergenerational Questions")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3a",
    attrs: {
      "id": "pAdJ"
    }
  }, [_vm._v("\n\t\t\t\t\tHolly Catterton Allen and Chris Barnett ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pAz1E"
    }
  }, [_c('b', [_c('span', {
    staticClass: "dropcap",
    staticStyle: {
      "color": "rgb(79,75,76)"
    },
    attrs: {
      "id": "A1kq"
    }
  }, [_vm._v("C")])]), _vm._v(" ommunity churches, emerging churches, evangelical churches, mainline churches,\n\t\t\t\t\tmissional churches, charismatic churches, Catholic churches—all types of Christian\n\t\t\t\t\tcommunities—are lamenting the silos created by age-segregated ministries. Leaders\n\t\t\t\t\tare now asking, “How can we bring the generations back together?” This renewed interest\n\t\t\t\t\tin intergenerational ministry is also grounded in a growing body of research that\n\t\t\t\t\tsupports the idea that intergenerational experiences contribute uniquely to sustainable,\n\t\t\t\t\tlong-term faith formation across all ages."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#a1",
      "id": "d1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "pA8b"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgb(79,75,76)"
    },
    attrs: {
      "id": "AqI0"
    }
  }, [_vm._v("Defining "), _c('i', [_vm._v("Multigenerational, Cross-Generational")]), _vm._v(", and "), _c('i', [_vm._v("Intergenerational")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pARf"
    }
  }, [_vm._v("\n\t\t\t\t\tIn general, we will define "), _c('i', [_vm._v("intergenerational ministry")]), _vm._v(" in this text as Christine Ross\n\t\t\t\t\tand I (Holly) did in our 2012 book, "), _c('i', [_vm._v("Intergenerational Christian Formation: Bringing\n\t\t\t\t\tthe Whole Church Together for Ministry, Community and Worship")]), _vm._v(": “Intergenerational\n\t\t\t\t\tministry occurs when a congregation intentionally combines the generations together\n\t\t\t\t\tin mutual serving, sharing, or learning within the core activities of the church\n\t\t\t\t\tin order to live out being the body of Christ to each other and the greater community.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#a2",
      "id": "d2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz18-6"
    }
  }, [_vm._v("\n\t\t\t\t\tThough the definition is a good basic description, it is not comprehensive, and\n\t\t\t\t\tit continues to prompt clarifying questions such as: Are the terms "), _c('i', [_vm._v("intergenerational")]), _vm._v("\n\t\t\t\t\tand "), _c('i', [_vm._v("multigenerational")]), _vm._v(" synonymous? Are the main benefits of intergenerational ministry\n\t\t\t\t\tfor children and youth? Must all the generations be present for an event to be called\n\t\t\t\t\tintergenerational? How does a generationally configured church begin the process\n\t\t\t\t\tof becoming more intentionally intergenerational? ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz18-7"
    }
  }, [_vm._v("\n\t\t\t\t\tThe terms "), _c('i', [_vm._v("multigenerational, cross-generational")]), _vm._v(", and "), _c('i', [_vm._v("intergenerational")]), _vm._v(" are often\n\t\t\t\t\tused interchangeably, though they carry different connotations. A useful resource\n\t\t\t\t\tfor exploring the distinctions among multi-, cross-, and inter- is the paper from\n\t\t\t\t\tthe United Church of Canada, "), _c('i', [_vm._v("Defining Multicultural, Cross-cultural, and Intercultural")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#a3",
      "id": "d3"
    }
  }, [_vm._v("3")])]), _vm._v("\n\t\t\t\t\tI (Chris) have applied the language from this document to the intergenerational space,\n\t\t\t\t\tcreating the following explanations: ")]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "lz18-10"
    }
  }, [_c('li', {
    attrs: {
      "id": "pz18-10"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "images/nec-10-1.png",
      "src": "images/nec-10-1.png"
    }
  }), _vm._v(" in the "), _c('i', [_vm._v("multi")]), _vm._v("generational environment, there is tolerance living alongside superficial\n\t\t\t\t\t\tand polite interaction; ")]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "pz18-11"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "images/nec-10-1.png",
      "src": "images/nec-10-1.png"
    }
  }), _vm._v(" in the "), _c('i', [_vm._v("cross")]), _vm._v("-generational environment, there is some sharing, listening, and learning,\n\t\t\t\t\t\tbut little individual or collective transformation; and ")]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "pz18-12"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "images/nec-10-1.png",
      "src": "images/nec-10-1.png"
    }
  }), _vm._v(" in the "), _c('i', [_vm._v("inter")]), _vm._v("generational environment, there is comprehensive "), _c('i', [_vm._v("mutuality, equality")]), _vm._v(",\n\t\t\t\t\t\tand "), _c('i', [_vm._v("reciprocity")]), _vm._v(" that makes individual or collective transformation more likely.\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz18-13"
    }
  }, [_vm._v("\n\t\t\t\t\tIn essence, the trajectory from multi- to inter- involves a greater depth of relationship,\n\t\t\t\t\ta change in the nature of the relationship, and an increasing openness to being changed\n\t\t\t\t\tthrough relationship with the “other.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#a4",
      "id": "d4"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "pz18-14"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgb(79,75,76)"
    },
    attrs: {
      "id": "A1XT"
    }
  }, [_vm._v("Benefiting More Than Just Children and Youth")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz18-15"
    }
  }, [_vm._v("\n\t\t\t\t\tDavid Goodwin’s research suggests that adult engagement with children and provision\n\t\t\t\t\tof meaningful opportunities for children to be involved in worship with adults will\n\t\t\t\t\t“assist children to grow in their faith, their love of God, and their connection\n\t\t\t\t\tto the church and its faith practices.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#a5",
      "id": "d5"
    }
  }, [_vm._v("5")])]), _vm._v(" His focus is on the benefit for children;\n\t\t\t\t\thowever, a crucial concept for proponents of intergenerational ministry is the idea\n\t\t\t\t\tthat it offers benefits for "), _c('i', [_vm._v("all")]), _vm._v(" ages. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz19-6"
    }
  }, [_vm._v("\n\t\t\t\t\tWhile momentum toward greater intergenerationality within churches is sometimes generated\n\t\t\t\t\tby those primarily concerned with younger generations"), _c('i', [_vm._v(",")]), _vm._v(" the initial impetus regarding\n\t\t\t\t\tthe importance of intergenerationality from a secular perspective arose from the\n\t\t\t\t\tfield of gerontology—that is, from an identification of the benefits for older generations\n\t\t\t\t\tof deeper engagement with younger generations."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#a6",
      "id": "d6"
    }
  }, [_vm._v("6")])]), _vm._v(" As Christine and I outlined in our\n\t\t\t\t\tbook, there are strong biblical, theological foundations as well as solid support\n\t\t\t\t\tfrom developmental, social learning, ecological systems, sociocultural, situative-sociocultural,\n\t\t\t\t\tand gerontological theory"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#a7",
      "id": "d7"
    }
  }, [_vm._v("7")])]), _vm._v(" for asserting that an intentionally intergenerational\n\t\t\t\t\tenvironment encourages and sustains lifelong discipleship for "), _c('i', [_vm._v("everyone")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz19-7"
    }
  }, [_vm._v("\n\t\t\t\t\tIntergenerational ministry is not just about (and of benefit to) children and youth;\n\t\t\t\t\tit is about (and of benefit to) people of all generations. ")]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "pz19-8"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgb(79,75,76)"
    },
    attrs: {
      "id": "AQNW"
    }
  }, [_vm._v("Must All Six Generations Be Present?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz19-9"
    }
  }, [_vm._v("\n\t\t\t\t\tOne commonly highlighted description of intergenerational ministry is, as described\n\t\t\t\t\tby James White, “two or more different age groups of people in a religious community\n\t\t\t\t\ttogether learning/growing/living in faith through in-common-experiences . . . and\n\t\t\t\t\tinteractive sharing.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#a8",
      "id": "d8"
    }
  }, [_vm._v("8")])]), _vm._v(" Basically, this definition involves different generations\n\t\t\t\t\tintentionally engaging in shared activity together; but more particularly, it highlights\n\t\t\t\t\tthe fact that it requires only two generations to be present for there to be the\n\t\t\t\t\tpotential for intentional intergenerational engagement. Thus, regardless of how many\n\t\t\t\t\tyears are assigned to a particular generation (typically fifteen to twenty years"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#a9",
      "id": "d9"
    }
  }, [_vm._v("9")])]), _vm._v("),\n\t\t\t\t\teven in congregations without representatives from all generations, there is still\n\t\t\t\t\tthe opportunity to embrace—and benefit from—an intentionally intergenerational approach\n\t\t\t\t\tto ministry. ")]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "pz19-10"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgb(79,75,76)"
    },
    attrs: {
      "id": "A4fl"
    }
  }, [_vm._v("Finding a Starting Place")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz19-11"
    }
  }, [_vm._v("\n\t\t\t\t\tJust as clarity around the terms multi-, cross-, and inter- can be useful for churches,\n\t\t\t\t\tso too can clarification around the difference between a primarily "), _c('i', [_vm._v("generationally")]), _vm._v("\n\t\t\t\t\tarranged community and a primarily "), _c('i', [_vm._v("intergenerationally")]), _vm._v(" arranged community. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz19-12"
    }
  }, [_vm._v("\n\t\t\t\t\tIn general, a "), _c('i', [_vm._v("generationally configured")]), _vm._v(" community defaults to age-based cohorts that\n\t\t\t\t\tsometimes join with other generations for specific "), _c('span', {
    attrs: {
      "id": "z20-6"
    }
  }, [_vm._v("activities together. For communities\n\t\t\t\t\tprimarily organized in this way, the challenge is to create opportunities for the\n\t\t\t\t\tdifferent generations to engage in well together. ")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz20-7"
    }
  }, [_vm._v("\n\t\t\t\t\tAn "), _c('i', [_vm._v("intergenerationally configured")]), _vm._v(" community defaults to all ages gathering together,\n\t\t\t\t\tthough sometimes things are done separately in age-based cohorts. For communities\n\t\t\t\t\tprimarily organized in this way, the challenge is to "), _c('i', [_vm._v("deepen")]), _vm._v(" intergenerational connections.\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz20-8"
    }
  }, [_vm._v("\n\t\t\t\t\tAn initial task for churches is to discern whether they are primarily generationally\n\t\t\t\t\tor intergenerationally configured (noting that each configuration calls for a blend\n\t\t\t\t\tof age-based and multi-age experiences); this process will help determine the foundational\n\t\t\t\t\tstarting point for their journey toward greater intergenerationality. Irrespective\n\t\t\t\t\tof the starting point, though, the challenge in either case is to implement more\n\t\t\t\t\tintentional intergenerational strategies that foster Christian spiritual formation\n\t\t\t\t\tfor all ages. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz20-9"
    }
  }, [_vm._v("\n\t\t\t\t\tAnd the chapters of this book, "), _c('i', [_vm._v("InterGenerate,")]), _vm._v(" were written with this precise challenge\n\t\t\t\t\tin mind. ")]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "pz20-10"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgb(79,75,76)"
    },
    attrs: {
      "id": "A1Jy"
    }
  }, [_vm._v("InterGenerate: An Overview")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz20-11"
    }
  }, [_vm._v("\n\t\t\t\t\tOne unique aspect of this book is that it is, like the conference, a "), _c('i', [_vm._v("blended")]), _vm._v(" collaboration\n\t\t\t\t\tof practitioners and scholars. Some of the chapter authors are academicians; other\n\t\t\t\t\tauthors are primarily ministers in the trenches; and some of the contributors are\n\t\t\t\t\tboth. Consequently, some chapters draw heavily from scholarly sources in sociological,\n\t\t\t\t\tbiblical, or theological fields, while other chapters derive mainly from direct ministry\n\t\t\t\t\texperience. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz20-12"
    }
  }, [_vm._v("\n\t\t\t\t\tThe book opens with a prologue that shares four brief stories vividly illustrating\n\t\t\t\t\thow cross-generational experiences can function and bless the church. The book is\n\t\t\t\t\tthen divided into five sections. The first section addresses primarily the "), _c('i', [_vm._v("why")]), _vm._v(" question:\n\t\t\t\t\tWhy should churches become more intentionally intergenerational? Parts two, three,\n\t\t\t\t\tfour, and five address the "), _c('i', [_vm._v("how")]), _vm._v(" question: How can churches become more intentionally\n\t\t\t\t\tintergenerational? ")]), _vm._v(" "), _c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "pz20-13"
    }
  }, [_c('i', [_vm._v("Part One: Becoming More Intentionally Intergenerational")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz20-14"
    }
  }, [_vm._v("\n\t\t\t\t\tPart One opens with Jason Santos’s chapter that places "), _c('i', [_vm._v("InterGenerate")]), _vm._v(" in the context\n\t\t\t\t\tof the current post-Christian landscape by addressing the "), _c('span', {
    attrs: {
      "id": "z21-6"
    }
  }, [_vm._v("foundational question,\n\t\t\t\t\t“Why should we move toward more intentionally intergenerational faith communities\n\t\t\t\t\t"), _c('i', [_vm._v("now?")]), _vm._v("” Next, Gareth Crispin and Darwin Glassford explore, in fresh ways, the biblical\n\t\t\t\t\tand theological foundations of intergenerational ministry. Last, Lynn Barger Elliott\n\t\t\t\t\tengages generational theory, creatively capturing its significance for churches that\n\t\t\t\t\tare seeking to bring six generations together. ")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "pz21-7"
    }
  }, [_c('i', [_vm._v("Part Two: Leading Intergenerational Change")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz21-8"
    }
  }, [_vm._v("\n\t\t\t\t\tThough many church leaders are initially excited about the idea of becoming more\n\t\t\t\t\tintergenerational in outlook and practice, the prospect of actually "), _c('i', [_vm._v("leading")]), _vm._v(" their\n\t\t\t\t\tchurches in that direction is daunting. Cory Seibel tackles this fear head-on with\n\t\t\t\t\this thorough treatment of the process of leading churches through change. Next, John\n\t\t\t\t\tRoberto offers the ten-thousand-foot view, outlining for visionaries and leaders\n\t\t\t\t\tseventeen "), _c('i', [_vm._v("principles")]), _vm._v(" for implementing intergenerational practices effectively. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz21-9"
    }
  }, [_vm._v("\n\t\t\t\t\tAddressing church leadership, Jessica Stollings draws on her expertise in helping\n\t\t\t\t\tbusinesses navigate the unprecedented reality of four generations working together\n\t\t\t\t\tin the workforce; she proposes that intergenerational church leadership is an untapped\n\t\t\t\t\tresource to help churches address complex generational challenges and thrive in the\n\t\t\t\t\tmidst of change. And Joseph Conway closes part two with his boots-on-the-ground perspective\n\t\t\t\t\tas a senior pastor leading a church on a six-year journey toward becoming more intentionally\n\t\t\t\t\tintergenerational in outlook and practice. Both Jessica and Joseph led engaging,\n\t\t\t\t\tinteractive workshops at the InterGenerate Conference which they have transposed\n\t\t\t\t\tinto these robust chapters on leadership. ")]), _vm._v(" "), _c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "pz21-10"
    }
  }, [_c('i', [_vm._v("Part Three: Current Research")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz21-11"
    }
  }, [_vm._v("\n\t\t\t\t\tMy coauthor Christine and I called for more empirical research to further explore\n\t\t\t\t\tthe benefits and challenges of intergenerational experience,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#a10",
      "id": "d10"
    }
  }, [_vm._v("10")])]), _vm._v(" so part three addresses\n\t\t\t\t\tthat research gap; it shares recent research that intersects with intergenerational\n\t\t\t\t\tministry practices. Canadian Tori Bennett Smit shares best intergenerational practices\n\t\t\t\t\tfrom her doctoral research with churches that have small numbers of children. Australian\n\t\t\t\t\tJoe Azzopardi describes his study designed to assess the impact of intergenerational\n\t\t\t\t\t"), _c('span', {
    attrs: {
      "id": "z22-6"
    }
  }, [_vm._v("Christian practices on well-being. Wilson McCoy presents the poignant findings of\n\t\t\t\t\this qualitative study of the spiritually formative impact of reading Scripture in\n\t\t\t\t\tan intergenerational small group environment; the participants in his study ranged\n\t\t\t\t\tfrom age ten to eighty. ")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "pz22-7"
    }
  }, [_c('i', [_vm._v("Part Four: Including Every Generation")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz22-8"
    }
  }, [_vm._v("\n\t\t\t\t\tPart four highlights the impact intergenerational Christian experiences can have\n\t\t\t\t\ton four marginalized generations in the church. Dawn Rundman makes a powerful case\n\t\t\t\t\tthat ministry with infants and toddlers can be "), _c('i', [_vm._v("intergenerational")]), _vm._v(", employing surprising\n\t\t\t\t\tsubheadings such as Early Childhood Ministry + Hospitality Ministry = Intergenerational\n\t\t\t\t\tMinistry. Dave Sanders addresses the new reality that millennials will be the primary\n\t\t\t\t\tteachers of the next generation—which he calls Screeners (others are calling the\n\t\t\t\t\tnewest generation Gen Z or iGen). My chapter (Holly) explores the exit of emerging\n\t\t\t\t\tadults from traditional churches and offers insights for joining these twentysomethings\n\t\t\t\t\ton their spiritual journeys. And finally, Diane Shallue’s chapter focuses on the\n\t\t\t\t\tmost marginalized generation in our churches—the seniors; she describes cross-age\n\t\t\t\t\topportunities for meaning making, storytelling, and listening that bless all who\n\t\t\t\t\tparticipate, fostering mutuality, equality, and reciprocity across the generations.\n\t\t\t\t\t")]), _vm._v(" "), _c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "pz22-9"
    }
  }, [_c('i', [_vm._v("Part Five: Unique Ministries and Approaches")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz22-10"
    }
  }, [_vm._v("\n\t\t\t\t\tSixteen exciting experiential workshops were presented at the InterGenerate Conference;\n\t\t\t\t\tpart five offers rich descriptions from six of those (other chapters in this book\n\t\t\t\t\tderive from workshops as well, though most are drawn from papers and keynote presentations).\n\t\t\t\t\tTammy Tolman winningly describes what intergenerational ministry is looking like\n\t\t\t\t\tin Australia; Karen DeBoer shares in her inimitable style the significance of telling\n\t\t\t\t\tour faith stories in interage settings; Linda Staats offers her unique “Cross†Generational”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#a11",
      "id": "d11"
    }
  }, [_vm._v("11")])]), _vm._v("\n\t\t\t\t\tperspective on glocal (a combination of global and local) concerns using the term\n\t\t\t\t\t"), _c('i', [_vm._v("accompaniment")]), _vm._v(" as the practice of “walking beside the other,” as Christ walks beside\n\t\t\t\t\tus, for the purpose of restoration and reconciliation within our communities (local)\n\t\t\t\t\tand the world (global). ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz22-16"
    }
  }, [_vm._v("\n\t\t\t\t\tLiz Perraud brings her two decades of experience with GenOn Ministries"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#a12",
      "id": "d12"
    }
  }, [_vm._v("12")])]), _vm._v(" to the intergenerational\n\t\t\t\t\ttable; her chapter tells a touching "), _c('span', {
    attrs: {
      "id": "z23-6"
    }
  }, [_vm._v("story of cross-generational reconciliation. Nancy\n\t\t\t\t\tGoing shares a wonderful, simple, and spiritually formative way to engage all ages\n\t\t\t\t\tusing images and Scripture. And Olivia Updegrove explains the joys and challenges\n\t\t\t\t\tshe is experiencing as she leads all-age worship using Sonja Stewart and Jerome Berryman’s\n\t\t\t\t\tYoung Children and Worship approach."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#a13",
      "id": "d13"
    }
  }, [_vm._v("13")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "pz23-7"
    }
  }, [_c('i', [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz23-8"
    }
  }, [_vm._v("\n\t\t\t\t\tCory Seibel’s concluding chapter, “The Intergenerationally Sticky Church,” draws\n\t\t\t\t\tfrom his insightful and penetrating keynote address at the conference. Cory’s cake-baking\n\t\t\t\t\timagery vividly calls the reader to consider six key ingredients that help churches\n\t\t\t\t\tstrengthen cohesion between people of diverse generations. ")]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "pz23-9"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgb(79,75,76)"
    },
    attrs: {
      "id": "APC"
    }
  }, [_vm._v("Our Hope")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz23-10"
    }
  }, [_vm._v("\n\t\t\t\t\tOur desire for this book is that it will equip and inspire senior pastors, children’s\n\t\t\t\t\tministers, small group leaders, youth ministers, curriculum writers, and other Christian\n\t\t\t\t\tleaders to envision and create more opportunities for intergenerational experiences\n\t\t\t\t\tmarked by "), _c('i', [_vm._v("mutuality, equality")]), _vm._v(", and "), _c('i', [_vm._v("reciprocity,")]), _vm._v(" thereby fostering the spiritual\n\t\t\t\t\ttransformation of children, youth, emerging adults, young adults, middle adults,\n\t\t\t\t\tand senior adults—that is, everyone in the body of Christ. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz23-11"
    }
  }, [_vm._v("\n\t\t\t\t\tFor intergenerational ministry to be genuinely transformative, it needs to be more\n\t\t\t\t\tfully understood, more deeply embraced, more genuinely modelled, more intentionally\n\t\t\t\t\tfacilitated, and more strategically embedded into the culture of faith communities.\n\t\t\t\t\tThe contributors to "), _c('i', [_vm._v("InterGenerate")]), _vm._v(" have written with these ends in mind. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz23-12"
    }
  }, [_vm._v("\n\t\t\t\t\t“Now to him who is able to do immeasurably more than all we ask or imagine, according\n\t\t\t\t\tto his power that is at work within us, to him be glory in the church and in Christ\n\t\t\t\t\tJesus "), _c('i', [_vm._v("throughout all generations")]), _vm._v(", for ever and ever” (Eph. 3:20–21, emphasis ours).\n\t\t\t\t\t")]), _vm._v(" "), _c('h5', {
    staticClass: "h5",
    attrs: {
      "id": "pAKrW"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgb(79,75,76)"
    },
    attrs: {
      "id": "ATb2"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "bibliography",
    attrs: {
      "id": "AJ8x"
    }
  }, [_c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "pA4zZ"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#d1",
      "id": "a1"
    }
  }, [_vm._v("1")])]), _vm._v("Authors, thinkers, and researchers who are highlighting the importance of intergenerational\n\t\t\t\t\t\tconnections to sustain faithful discipleship include David Kinnaman, "), _c('i', [_vm._v("You Lost Me:\n\t\t\t\t\t\tWhy Young Christians Are Leaving Church")]), _vm._v(" . . . "), _c('i', [_vm._v("And Rethinking Faith")]), _vm._v(" (Grand Rapids:\n\t\t\t\t\t\tBaker Books, 2011); Dr. Kara E. Powell and Dr. Chap Clark, "), _c('i', [_vm._v("Sticky Faith: Everyday\n\t\t\t\t\t\tIdeas to Build Lasting Faith in Your Kids")]), _vm._v(" (Grand Rapids: Zondervan, 2011); Kathie\n\t\t\t\t\t\tAmidei, Jim Merhaut, and John Roberto, "), _c('i', [_vm._v("Generations Together: Caring, Praying, Learning,\n\t\t\t\t\t\tCelebrating, & Serving Faithfully")]), _vm._v(" (Naugatuck, CT: LifelongFaith Associates, 2014);\n\t\t\t\t\t\tand Christian Smith with Melinda Lundquist Denton, "), _c('i', [_vm._v("Soul Searching: The Religious\n\t\t\t\t\t\tand Spiritual Lives of American Teenagers")]), _vm._v(" (New York: Oxford University Press, 2005).\n\t\t\t\t\t\tBeyond the North American context, movements like Here2Stay (here2stay ."), _c('a', {
    attrs: {
      "href": "http://org.au",
      "id": "ANC",
      "target": "_blank"
    }
  }, [_vm._v("org.au")]), _vm._v(") in\n\t\t\t\t\t\tAustralia and Faithfull Generation ("), _c('a', {
    attrs: {
      "href": "http://faithfullgeneration.com",
      "id": "AVkW",
      "target": "_blank"
    }
  }, [_vm._v("faithfullgeneration.com")]), _vm._v(") in the United Kingdom\n\t\t\t\t\t\tare also identifying—and responding to—similar conclusions. ")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "pz24-6"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#d2",
      "id": "a2"
    }
  }, [_vm._v("2")])]), _vm._v("Holly Catterton Allen and Christine Lawton Ross, "), _c('i', [_vm._v("Intergenerational Christian Formation:\n\t\t\t\t\t\tBringing the Whole Church Together in Ministry, Community and Worship")]), _vm._v(" (Downers Grove,\n\t\t\t\t\t\tIL: InterVarsity Press, 2012), 17. ")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "pz24-7"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#d3",
      "id": "a3"
    }
  }, [_vm._v("3")])]), _vm._v("United Church of Canada, “Defining Multicultural, Cross-cultural, and Intercultural”\n\t\t\t\t\t\t(Toronto, Ontario, Canada: The United Church of Canada, 2011), "), _c('a', {
    attrs: {
      "href": "http://ResearchGate.net",
      "id": "Ao_q",
      "target": "_blank"
    }
  }, [_vm._v("http://ResearchGate.net")]), _vm._v(".\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "pz24-8"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#d4",
      "id": "a4"
    }
  }, [_vm._v("4")])]), _vm._v(" Chris Barnett, coauthor of this introduction, brings this valuable perspective\n\t\t\t\t\t\tfrom his work in Australia. ")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "pz24-9"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#d5",
      "id": "a5"
    }
  }, [_vm._v("5")])]), _vm._v("David Goodwin, "), _c('i', [_vm._v("Lost in Transition—or Not? Addressing the Problem of Children Leaving\n\t\t\t\t\t\tthe Church as They Make the Transition from Childhood to Youth")]), _vm._v(" (North Richmond, Australia:\n\t\t\t\t\t\tKidsreach, 2013), 23. ")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "pz24-10"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#d6",
      "id": "a6"
    }
  }, [_vm._v("6")])]), _vm._v("Allen and Ross, "), _c('i', [_vm._v("Intergenerational Christian Formation")]), _vm._v(", 134. ")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "pz24-11"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#d7",
      "id": "a7"
    }
  }, [_vm._v("7")])]), _vm._v("Allen and Ross, "), _c('i', [_vm._v("Intergenerational Christian Formation,")]), _vm._v(" chapters 5–12. ")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "pz24-12"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#d8",
      "id": "a8"
    }
  }, [_vm._v("8")])]), _vm._v("James W. White, "), _c('i', [_vm._v("Intergenerational Religious Education: Models, Theories and Prescription\n\t\t\t\t\t\tfor Interage Life and Learning in the Faith Community")]), _vm._v(" (Birmingham: Religious Education\n\t\t\t\t\t\tPress, 1988), 18. ")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "pz24-13"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#d9",
      "id": "a9"
    }
  }, [_vm._v("9")])]), _vm._v("Gary L. McIntosh, "), _c('i', [_vm._v("One Church, Four Generations: Understanding and Reaching All Ages\n\t\t\t\t\t\tin Your Church")]), _vm._v(" (Grand Rapids: Baker Books, 2002), 199. ")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "pz24-14"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#d10",
      "id": "a10"
    }
  }, [_vm._v("10")])]), _vm._v("Allen and Ross, "), _c('i', [_vm._v("Intergenerational Christian Formation,")]), _vm._v(" 174. ")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "pz24-15"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#d11",
      "id": "a11"
    }
  }, [_vm._v("11")])]), _vm._v("The use of the phrase “Cross†Generational” throughout Linda’s chapter is used to\n\t\t\t\t\t\tdescribe the concept that all generations gather around the cross of Jesus Christ\n\t\t\t\t\t\tand journey together. ")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "pz24-16"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#d12",
      "id": "a12"
    }
  }, [_vm._v("12")])]), _vm._v("GenOn Ministries exists to equip churches to develop disciples through intergenerational\n\t\t\t\t\t\tministry and relationships. GenOn was a sponsor of the InterGenerate Conference;\n\t\t\t\t\t\tsee "), _c('a', {
    attrs: {
      "href": "http://www.genonministries.org",
      "id": "AigB",
      "target": "_blank"
    }
  }, [_vm._v("www.genonministries.org")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "pz24-17"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#d13",
      "id": "a13"
    }
  }, [_vm._v("13")])]), _vm._v("Sonja M. Stewart and Jerome W. Berryman, "), _c('i', [_vm._v("Young Children and Worship")]), _vm._v(" (Louisville:\n\t\t\t\t\t\tWestminster John Knox Press, 1989), "), _c('a', {
    attrs: {
      "href": "http://www.childrenandworship.org",
      "id": "AM-3",
      "target": "_blank"
    }
  }, [_vm._v("www.childrenandworship.org")]), _vm._v(". ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a62361a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter04.vue
// module id = 78
// module chunks = 0